import React from 'react';

import { useDevice } from '@bonnet/next/device';

export function DynamicPlaceholder({ height } = {}) {
    // This component is used to create a placeholder with a dynamic height for use with nextjs dynamic()
    const device = useDevice();

    const { xs, sm, md, lg } = height;

    let placeholderHeight = 0;
    switch (device.mediaType) {
        case 'xs':
            placeholderHeight = xs;
            break;
        case 'sm':
            placeholderHeight = sm;
            break;
        case 'md':
            placeholderHeight = md;
            break;
        case 'lg':
            placeholderHeight = lg;
            break;
        default:
            placeholderHeight = xs || sm || md || lg || 0;
    }

    return (
        <div style={{ height: placeholderHeight }} />
    );
}
